import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';

@Component({
  selector: 'app-donation-requests',
  templateUrl: './donation-requests.component.html',
  styleUrls: ['./donation-requests.component.scss']
})
export class DonationRequestsComponent implements OnInit {

  public donationRequests: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public status = 'Pending';
  public onChangeSearch = new Subject<string>();
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public maxDate = '';
  public allPaymentTypes: any = [];
  public payment_type_id = '';

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.getList('');
    this.getAllPaymentTypes();
  }

  navigateTo(url) {
    this.router.navigate([url]);
  }

  getList(_type) {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    const data = {
      from_date: from_date,
      to_date: to_date,
      status: this.status,
      page: this.page,
      per_page: this.perPage,
      payment_type_id: this.payment_type_id
    };

    this.apiService.getDataFromServer(`/bhakt_niwas_donations?from_date=${from_date}&end_date=${to_date}&page=${this.page}&per_page=${this.perPage}`).subscribe((res: any) => {
      this.appComponent.hideLoader();
      this.donationRequests = res;
      this.donationRequests.data.map(item => {
        item.created_at = moment.utc(item.created_at).local().format('DD-MM-YYYY h:mm a z');
        item.payment_detail = item.payment_details && item.payment_details.length ? item.payment_details[0] : null;
      });
      this.totalCount = res.total;
    }, (error) => {
      this.appComponent.hideLoader();
      console.log(error);
    });
  }

  getAllPaymentTypes() {
    this.apiService.getDataFromServer('/payment_types').subscribe(
      res => {
        this.allPaymentTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }

  onPageChange(event) {
    this.page = event;
    this.getList('');
  }

  onPerPageChange(event) {
    this.perPage = event;
    this.page = 1;
    this.getList('');
  }

  exportData() {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    const data = {
      from_date: from_date,
      to_date: to_date,
      status: this.status,
      payment_type_id: this.payment_type_id
    };

    this.apiService.getDataFromServer(`/export_donation_requests?from_date=${from_date}&to_date=${to_date}&status=${this.status}&payment_type_id=${this.payment_type_id}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry = res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponent.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
          this.appComponent.hideLoader();
        });
      }
      this.appComponent.hideLoader();
    }, (error) => {
      this.appComponent.hideLoader();
      console.log('error' , error);
    });
  }

  changeStatus(requestId, status) {
    this.appComponent.showLoader();
    const data = {
      id: requestId,
      status: status
    };

    this.apiService.putDataToServer('/donation-requests/' + requestId + '/status', data).subscribe((res: any) => {
      this.appComponent.hideLoader();
      this.appComponent.showMessageAlert('Status updated successfully', 'success');
      this.getList('');
    }, (error) => {
      this.appComponent.hideLoader();
      this.appComponent.showMessageAlert('An error occurred while updating status.', 'error');
      console.log(error);
    });
  }
}